// 1.

// import React, {
//     useEffect,
//     useState,
//     useContext,
//     forwardRef,
// } from "react";

// import {
//     Chart as ChartJS,
//     LinearScale,
//     CategoryScale,
//     Tooltip,
//     Legend,
// } from "chart.js";

// import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Chart } from "react-chartjs-2";

// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";

// import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";
// import { PASS_KEY, WEB_KEY } from "../../../../../../../../api/AxiosApi";
// import { PrAnalysisApi } from "../../../../../../../../api/Api";

// /* ✅ Register required chart.js components */
// ChartJS.register(
//     LinearScale,
//     CategoryScale,
//     MatrixController,
//     MatrixElement,
//     Tooltip,
//     Legend
// );

// export function getDateTimeForDashboardTab1(date = new Date()) {
//   const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//   const tenDaysAgo = new Date(date);
//   tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
//   const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//   return {
//     Today: formattedCurrentDate,
//     LastDay: formattedTenDaysAgo,
//   };
// }

// const Tab4SpecificYield = forwardRef((props, ref) => {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext);

//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//       const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const credentials = {
//         USER: localStorage.getItem("LoginID") || "",
//         LCODE: localStorage.getItem("LCODE") || "",
//         PASS_KEY: PASS_KEY,
//         WEB_KEY: WEB_KEY,
//         DT1: StartDate,
//         DT2: EndDate,
//     };

//     /* 🔄 Fetch API Data */
//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             const res = await PrAnalysisApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             setError("Failed to fetch data");
//             setLogData([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials.USER]);

//     /* 🔥 X-axis labels (USER) */
//     const users = logData.map(
//         (d, i) => d.USER || `User-${i + 1}`
//     );

//     /* 🔥 Matrix Heatmap Data (Specific_Yield) */
//     const heatMapData = logData.map((d, i) => ({
//         x: d.USER || `User-${i + 1}`,
//         y: "Specific Yield",
//         v: Number(d.Specific_Yield) || 0,
//     }));

//     console.log(logData)
//     return (
//         <div ref={ref} className="row" >
//             <div
//                 className="col-md-12"
//                 style={{ height: "", position: "relative" }}
//             >
               

//                 {/* ⏳ Loader */}
//                 {loading ? (
//                     <div className="d-flex justify-content-center align-items-center h-100">
//                         <CircularProgress />
//                     </div>
//                 ) : error ? (
//                     <div className="text-danger text-center">{error}</div>
//                 ) : (
//                     <Chart
//                         type="matrix"
//                         plugins={[ChartDataLabels]}
//                         data={{
//                             datasets: [
//                                 {
//                                     data: heatMapData,

//                                     backgroundColor: (ctx) => {
//                                         const v = ctx.raw?.v ?? 0;
//                                         if (v === 0) return "#ff0000";
//                                         if (v < 1) return "#ff8c00";
//                                         if (v < 1.5) return "#ffff00";
//                                         if (v < 1.8) return "#7CFC00";
//                                         return LoggedInUserInfo?.dash_color || "#00c853";
//                                     },

//                                     width: ({ chart }) =>
//                                         chart.chartArea
//                                             ? chart.chartArea.width / users.length
//                                             : 30,

//                                     height: ({ chart }) =>
//                                         chart.chartArea
//                                             ? chart.chartArea.height / 1.6
//                                             : 40,
//                                 },
//                             ],
//                         }}
//                         options={{
//                             responsive: true,
//                             maintainAspectRatio: false,

//                             plugins: {
//                                 legend: { display: false },

//                                 tooltip: {
//                                     callbacks: {
//                                         label: (ctx) =>
//                                             `${ctx.raw?.x} : ${ctx.raw?.v?.toFixed(2)}`,
//                                     },
//                                 },

//                                 datalabels: {
//                                     display: true,
//                                     formatter: (ctx) => ctx?.v?.toFixed(2),
//                                     color: "#000",
//                                     anchor: "center",
//                                     align: "center",
//                                     font: {
//                                         size: 12,
//                                         weight: "bold",
//                                     },
//                                 },
//                             },

//                             scales: {
//                                 x: {
//                                     type: "category",
//                                     labels: users,
//                                     ticks: {
//                                         autoSkip: false,
//                                         maxRotation: 45,
//                                         minRotation: 45,
//                                         font: {
//                                             size: 11,
//                                             weight: "bold",
//                                         },
//                                     },
//                                 },

//                                 y: {
//                                     type: "category",
//                                     labels: ["Specific Yield"],
//                                     offset: true,
//                                     ticks: {
//                                         font: {
//                                             size: 12,
//                                             weight: "bold",
//                                         },
//                                     },
//                                 },
//                             },
//                         }}
//                     />
//                 )}
//             </div>
//         </div>
//     );
// });

// export default Tab4SpecificYield;


// 2.

import React, {
    useEffect,
    useState,
    useContext,
    forwardRef,
} from "react";

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
} from "chart.js";

import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";

import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";

import { AuthenticationContext } from "../../../../../../../../context/AuthenticationContext";
import { PASS_KEY, WEB_KEY } from "../../../../../../../../api/AxiosApi";
import { PrAnalysisApi } from "../../../../../../../../api/Api";

/* ✅ Register required chart.js components */
ChartJS.register(
    LinearScale,
    CategoryScale,
    MatrixController,
    MatrixElement,
    Tooltip,
    Legend
);

export function getDateTimeForDashboardTab1(date = new Date()) {
  const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
  const tenDaysAgo = new Date(date);
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  return {
    Today: formattedCurrentDate,
    LastDay: formattedTenDaysAgo,
  };
}

const Tab4SpecificYield = forwardRef((props, ref) => {
    const { LoggedInUserInfo } = useContext(AuthenticationContext);

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
      const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const credentials = {
        USER: localStorage.getItem("LoginID") || "",
        LCODE: localStorage.getItem("LCODE") || "",
        PASS_KEY: PASS_KEY,
        WEB_KEY: WEB_KEY,
        DT1: StartDate,
        DT2: EndDate,
    };

    /* 🔄 Fetch API Data */
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await PrAnalysisApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data");
            setLogData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.USER]);

    /* 🔥 X-axis labels (USER) */
    const users = logData.map(
        (d, i) => d.DATET || `User-${i + 1}`
    );

    /* 🔥 Matrix Heatmap Data (Specific_Yield) */
    const heatMapData = logData.map((d, i) => ({
        x: d.DATET || `User-${i + 1}`,
        y: "Specific Yield",
        v: Number(d.Specific_Yield) || 0,
    }));

    console.log(logData)
    return (
        <div ref={ref} className="row" >
            <div
                className="col-md-12"
                style={{ height: "", position: "relative" }}
            >
               

                {/* ⏳ Loader */}
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center h-100">
                        <CircularProgress />
                    </div>
                ) : error ? (
                    <div className="text-danger text-center">{error}</div>
                ) : (
                    <Chart
                        type="matrix"
                        plugins={[ChartDataLabels]}
                        data={{
                            datasets: [
                                {
                                    data: heatMapData,

                                    backgroundColor: (ctx) => {
                                        const v = ctx.raw?.v ?? 0;
                                        if (v === 0) return "#ff0000";
                                        if (v < 1) return "#ff8c00";
                                        if (v < 1.5) return "#ffff00";
                                        if (v < 1.8) return "#7CFC00";
                                        return  "#00c853";
                                    },

                                    width: ({ chart }) =>
                                        chart.chartArea
                                            ? chart.chartArea.width / users.length
                                            : 30,

                                    height: ({ chart }) =>
                                        chart.chartArea
                                            ? chart.chartArea.height / 1.6
                                            : 40,
                                },
                            ],
                        }}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,

                            plugins: {
                                legend: { display: false },

                                tooltip: {
                                    callbacks: {
                                        label: (ctx) =>
                                            `${ctx.raw?.x} : ${ctx.raw?.v?.toFixed(2)}`,
                                    },
                                },

                                datalabels: {
                                    display: true,
                                    formatter: (ctx) => ctx?.v?.toFixed(2),
                                    color: "#000",
                                    anchor: "center",
                                    align: "center",
                                    font: {
                                        size: 12,
                                        weight: "bold",
                                    },
                                },
                            },

                            scales: {
                                x: {
                                    type: "category",
                                    labels: users,
                                    ticks: {
                                        autoSkip: false,
                                        maxRotation: 45,
                                        minRotation: 45,
                                        font: {
                                            size: 11,
                                            weight: "bold",
                                        },
                                    },
                                },

                                y: {
                                    type: "category",
                                    labels: ["Specific Yield"],
                                    offset: true,
                                    ticks: {
                                        font: {
                                            size: 12,
                                            weight: "bold",
                                        },
                                    },
                                },
                            },
                        }}
                    />
                )}
            </div>
        </div>
    );
});

export default Tab4SpecificYield;
